// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalendarTwoToneSvg from "@ant-design/icons-svg/es/asn/CalendarTwoTone";
import AntdIcon from '../components/AntdIcon';

var CalendarTwoTone = function CalendarTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalendarTwoToneSvg
  }));
};

CalendarTwoTone.displayName = 'CalendarTwoTone';
export default React.forwardRef(CalendarTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CalendarTwoTone.js
// module id = 711
// module chunks = 0